<template>
  <div>
    <div class="header">
      <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/r2.png" />
      <div class="wrap1">
        <span class="word3">请上传相关资料。</span>
        <span class="word4">在待提交状态时，您可以随时补充或修改资料。</span>
      </div>
    </div>
    <div class="box3"></div>
    <!-- 个人 -->
    <div v-if="this.state.institutionType === 2" class="four-one">
      <a-form :form="form" style="margin: 40px 0 0 39px">
        <a-row :gutter="24">
          <!-- 基本资料 -->
          <div class="basics">
            <div class="section4">
              <div class="mod4"></div>
              <span class="txt1">基本资料</span>
            </div>
            <a-col :span="12">
              <div class="title">姓名</div>
              <a-form-item>
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'username',
                    {
                      rules: [
                        {
                          pattern: /^.{2,30}$/,
                          message: '请输入长度为2~10位的负责人姓名',
                        },
                      ],
                      initialValue: this.state.username,
                    },
                  ]"
                  placeholder="请输入您的真实姓名"
                />
              </a-form-item>
              <div class="title">主要联络手机号</div>
              <a-form-item>
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'mobile',
                    {
                      rules: [
                        {
                          pattern: /^1[3456789]\d{9}$/,
                          message: '请输入正确的手机号',
                        },
                      ],
                      initialValue: this.state.mobile,
                    },
                  ]"
                  placeholder="请输入您常用的手机号" :maxLength="11"
                />
              </a-form-item>
              <div class="title">性别</div>
              <a-form-item>
                <a-select
                  v-decorator="[
                    'teacherGender',
                    {
                      rules: [{ required: true, message: '请选择' }],
                      initialvalue: this.state.teacherGender,
                    },
                  ]"
                  placeholder="请选择您的性别"
                  style="width: 150px"
                >
                  <a-select-option value="1"> 男 </a-select-option>
                  <a-select-option value="2"> 女 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="11">
                  <div class="title">身份证号</div>
                  <a-form-item>
                    <a-input
                      v-decorator="[
                        'cardNo',
                        {
                          rules: [
                            {
                              required: true,
                              pattern:
                                /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                              message: '请输入正确的身份证号',
                            },
                          ],
                          initialValue: this.state.cardNo,
                        },
                      ]"
                      placeholder="请输入您的身份证号"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="11" v-if="false">
                  <div class="title">银行卡号</div>
                  <a-form-item>
                    <a-input
                      v-decorator="[
                        'bankCardNo',
                        {
                          rules: [
                            {
                              pattern: /^\d{16,19}$/,
                              message: '请输入正确的银行卡号',
                            },
                          ],

                          initialValue: this.state.bankCardNo,
                        },
                      ]"
                      placeholder="请输入您常用的银行卡号"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="11" v-if="false">
                  <div class="title">开户行</div>
                  <a-form-item>
                    <a-input
                      v-decorator="[
                        'bankName',
                        {
                          rules:[
                            {
                          pattern: /^.{1,45}$/,
                          message: '请输入45个字符以内的的开户行',
                        }],
                          initialValue: this.state.bankName,
                        },
                      ]"
                      placeholder="请输入开户行"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="11">
                  <div class="title">执教年限</div>
                  <a-form-item>
                    <a-input-number
                      :min="0"
                      :max="100"
                      style="width: 100%"
                      v-decorator="[
                        'teachingYears',
                        {
                          rules: [
                            {
                              pattern: /^[0-9]*[1-9][0-9]*$/,
                              message: '请输入为正整数的执教年限',
                            },
                          ],
                          initialValue: this.state.teachingYears,
                        },
                      ]"
                      placeholder="请输入执教年限"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="11">
                  <div class="title">授课方向</div>
                  <a-form-item>
                    <a-input
                      v-decorator="[
                        'applyCourseType',
                        {
                          rules: [
                            {
                              pattern: /^.{1,50}$/,
                              required: requiredSetting.length && requiredSetting[7].settingValue == '1',
                              message: '请输入50个字符以内的授课方向',
                            },
                          ],
                          initialValue: this.state.applyCourseType,
                        },
                      ]"
                      placeholder="请输入授课方向"
                    />
                  </a-form-item>
                </a-col>
            <a-col :span="24">
              <div class="title">简介</div>
              <a-form-item>
                <a-textarea
                  v-decorator="[
                    'teacherIntro',
                    {
                      rules: [{ validator: teacherIntroRules }],
                      validateTrigger: 'blur',
                    },
                  ]"
                  placeholder="请简单介绍自己，多行输入"
                  :auto-size="{
                    minRows: 5,
                    maxRows: 6,
                  }"
                  :maxLength="2000"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :required="true">
                <div class="title" ref="avatarRef">正面免冠照片（2寸）</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_fullFaced"
                  class="fullFaced"
                  ref="teacherBareheadedImgUrl"
                  :isSingle="false"
                  :maxlength="1"
                  :maxFileSize="204800"
                  :imageMatchHeight="626"
                  :imageMatchWidth="413"
                  messageTitle="正面免冠照片"
                  :sourceFileList="sourceFileList_fullFaced"
                ></c-upload>
                <!-- 限制照片为两寸  :twoInches="true"-->
                <div class="remark">
                  符合宽高413×626像素200KB以内，支持jpeg,jpg,png
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <!-- --------------------------------------------------------------------- -->
              <a-form-item :required="true">
                <div class="title">头像</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_headPortrait"
                  class="headPortrait"
                  :isSingle="false"
                  :maxlength="1"
                  :maxFileSize="1048576"
                  ref="teacherImgUrl"
                  :sourceFileList="sourceFileList_teacherImgUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <div class="section18"></div>
            </a-col>
          </div>
          <!-- 学历信息 -->
          <div class="information">
            <a-col :span="24">
              <div class="section4">
                <div class="mod4"></div>
                <span class="txt1">学历信息</span>
              </div>
            </a-col>
            <a-col :span="24">
              <div class="education">学历及毕业院校
                <span class="require">({{ requiredSetting.length && (requiredSetting[0].settingValue == '0' && requiredSetting[1].settingValue == '0')?'选':'必' }}填)</span>
              </div>
              <div class="education-rule" ref="educationRef">
                *请上传所有高中以上学历
              </div>
            </a-col>
            <div
              class="xueli"
              v-for="(item, index) in state.educationInfoList"
              :key="index"
            >
              <a-col :span="18" v-if="index !== 0">
                <div class="outer9"></div>
              </a-col>
              <a-col :span="7">
                <a-form-item>
                  <a-select
                    v-decorator="[
                      `educationInfoList[${index}].recordSchooling`,
                      {
                        rules: [{ required: requiredSetting.length && (requiredSetting[0].settingValue == '1' || requiredSetting[1].settingValue == '1'), message: '请选择您的学历' }],
                        initialValue: item.recordSchooling || undefined,
                      },
                    ]"
                    style="width: 150px"
                    placeholder="请选择您的学历"
                  >
                    <a-select-option
                      v-for="(item, index) in educationSelect"
                      :key="index"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="13">
                <a-form-item>
                  <a-input
                    v-decorator="[
                      `educationInfoList[${index}].graduatedSchool`,
                      {
                        rules: [
                          { required: requiredSetting.length && (requiredSetting[0].settingValue == '1' || requiredSetting[1].settingValue == '1') || form.getFieldValue(`educationInfoList[${index}].recordSchooling`), message: '请输入您的毕业院校' },
                        ],
                        initialValue: item.graduatedSchool,
                      },
                    ]"
                    placeholder="请输入毕业院校"
                  />
                </a-form-item>
              </a-col>

              <a-col v-if="index !== 0" :span="4">
                <img
                  src="/delete.png"
                  style="width: 16px; height: 16px"
                  alt=""
                />
                <a-button
                  class="btn"
                  type="link"
                  @click="deleteEducation(index)"
                  style="margin-left: -4px"
                >
                  删除</a-button
                >
              </a-col>
              <a-col :span="7" style="height: 25px">
                <a-form-item :required="true">
                  <div class="card">学历证({{requiredSetting.length && requiredSetting[0].settingValue == '1'?'必':'选'}}填)</div>
                  <c-upload
                    accept="image/*"
                    @uploadSuccess="uploadSuccess_diploma($event, index)"
                    class="diploma"
                    :isSingle="false"
                    :maxlength="1"
                    ref="diploma"
                    :sourceFileList="item.schoolingUrlList"
                  ></c-upload>
                </a-form-item>
              </a-col>
              <a-col :span="13">
                <a-form-item :required="true">
                  <div class="card">学位证({{requiredSetting.length && requiredSetting[1].settingValue == '1'?'必':'选'}}填)</div>
                  <c-upload
                    accept="image/*"
                    @uploadSuccess="uploadSuccess_degreeUrl($event, index)"
                    class="diploma"
                    :isSingle="false"
                    :maxlength="1"
                    ref="degreeImgUrl"
                    :sourceFileList="item.degreeUrlList"
                  ></c-upload>
                </a-form-item>
              </a-col>
            </div>
            <a-col :span="18">
              <a-form-item>
                <a-button
                  style="width: 365px; height: 42px"
                  type="primary"
                  ghost
                  @click="addEducationInformation"
                  v-if="state.educationInfoList.length < 5"
                >
                  + 新增学历信息
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <div class="section18"></div>
            </a-col>
          </div>
          <!-- 其他资料 -->

          <div class="attachments">
            <a-col :span="24">
              <div class="section4">
                <div class="mod4"></div>
                <span class="txt1">其他资料</span>
              </div>
            </a-col>
            <a-col :span="9">
              <a-form-item :required="true">
                <div class="card" ref="IDCardRef">身份证（正面）</div>
                <c-upload
                  accept="image/*"
                  :isSingle="false"
                  :maxlength="1"
                  class="frontIDCard"
                  @uploadSuccess="uploadSuccess_frontIDCard"
                  ref="cardFrontUrl"
                  :sourceFileList="sourceFileList_cardFrontUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :required="true">
                <div class="card">身份证（反面）</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_backIDCard"
                  class="backIDCard"
                  :isSingle="false"
                  :maxlength="1"
                  ref="cardBackUrl"
                  :sourceFileList="sourceFileList_cardBackUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <div class="card" ref="healthImgRef">健康证明（{{requiredSetting.length && requiredSetting[4].settingValue == '1'?'必':'选'}}填,至多上传5张）</div>
                <c-upload
                  accept="image/*"
                  class="proveHealth"
                  :isSingle="false"
                  :maxlength="5"
                  ref="healthImgUrl"
                  :sourceFileList="reqDesc.healthUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <div class="card">老师资质证书（{{requiredSetting.length && requiredSetting[6].settingValue == '1'?'必':'选'}}填,至多上传5张）</div>
                <c-upload
                  accept="image/*"
                  class="proveHealth"
                  :isSingle="false"
                  :maxlength="5"
                  ref="qualification"
                  :sourceFileList="reqDesc.qualification"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="9">
              <a-form-item>
                <div class="card">无犯罪记录证明（{{requiredSetting.length && requiredSetting[2].settingValue == '1'?'必':'选'}}填）</div>
                <c-upload
                  accept="image/*"
                  class="prove"
                  :isSingle="false"
                  :maxlength="1"
                  ref="noCrimeImgUrl"
                  :sourceFileList="sourceFileList_noCrimeUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item>
                <div class="card">无犯罪记录证明有效期（{{requiredSetting.length && requiredSetting[9].settingValue == '1'?'必':'选'}}填）</div>
                <a-date-picker 
                  v-decorator="[
                    'noCrimeExpiryDate',
                    {
                      rules: [
                          {
                            required: requiredSetting.length && requiredSetting[9].settingValue == '1',
                            message: '请选择无犯罪记录证明有效期',
                          },
                        ],
                      initialValue: this.state.noCrimeExpiryDate,
                    },
                  ]" :disabled-date="disabledDate"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <div class="card">从业经验（{{requiredSetting.length && requiredSetting[8].settingValue == '1'?'必':'选'}}填,至多上传5张）</div>
                <c-upload
                  accept="image/*"
                  class="proveHealth"
                  :isSingle="false"
                  :maxlength="5"
                  ref="experienceUrl"
                  :sourceFileList="reqDesc.experience"
                ></c-upload>
              </a-form-item>
            </a-col>
          </div>
        </a-row>
        <div class="section27"></div>
        <a-form-item class="footer">
          <a-button
            class="button"
            :loading="saveloading"
            type="primary"
            ghost
            @click="save"
          >
            保存
          </a-button>
          <a-button
            @click="submit"
            class="button"
            type="primary"
            html-type="submit"
            :loading="loading"
          >
            确认提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <!-- 课程方 -->
    <div v-if="this.state.institutionType === 1" class="four-two">
      <a-form style="margin: 40px 0 0 39px" :form="form">
        <a-row :gutter="24">
          <!-- 基本资料 -->
          <div class="basics">
            <div class="section4">
              <div class="mod4"></div>
              <span class="txt1">基本资料</span>
            </div>
            <a-col :span="12">
              <div class="title">课程方名称</div>
              <a-form-item>
                <a-input
                  :disabled="state.auditFailed"
                  v-decorator="[
                    'institutionName',
                    {
                      rules: [
                        {
                          pattern: /^.{2,45}$/,
                          message: '请输入长度为2~45位的课程方名字',
                        },
                      ],
                      initialValue: this.state.institutionName,
                    },
                  ]"
                  placeholder="请输入课程方名"
                />
              </a-form-item>
            </a-col>
            <a-col :span="18">
              <div class="title">课程方详细地址</div>
              <a-form-item>
                <a-input
                  v-decorator="[
                    'address',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^.{2,50}$/,
                          message: '请输入长度为2~50位的的课程方地址',
                        },
                      ],
                      getValueFromEvent: (event) => {
                        return event.target.value.trim()
                      },
                      initialValue: this.state.address,
                    },
                  ]"
                  placeholder="请填写课程方所在详细地址"
                />
              </a-form-item>
            </a-col>
            <a-col :span="18">
              <a-form-item>
                <div class="card" ref="certificateRef">营业执照复印件：</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_certificateUrl"
                  class="certificateUrl"
                  :isSingle="false"
                  :maxlength="1"
                  ref="certificateUrl"
                  :sourceFileList="sourceFileList_certificateUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <div class="title">课程方负责人</div>
              <a-form-item>
                <a-input
                  v-decorator="[
                    'username',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/,
                          message: '请输入长度为2~10位的负责人姓名',
                        },
                      ],
                      getValueFromEvent: (event) => {
                        return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(event.target.value)
                          ? event.target.value
                          : event.target.value.slice(0, -1)
                      },
                      initialValue: this.state.username,
                      validateTrigger: 'change',
                    },
                  ]"
                  placeholder="请输入负责人的真实姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <div class="title">课程方负责人手机号</div>
              <a-form-item>
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'mobile',
                    {
                      rules: [
                        {
                          pattern: /^1[3456789]\d{9}$/,
                          message: '请输入正确的手机号',
                        },
                      ],
                      initialValue: this.state.mobile,
                      validateTrigger: 'change',
                    },
                  ]"
                  placeholder="请输入课程方负责人的手机号"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item>
                <div class="card" ref="corporationRef">法定代表人身份证（正面）</div>
                <c-upload
                  accept="image/*"
                  :isSingle="false"
                  :maxlength="1"
                  class="frontIDCard"
                  @uploadSuccess="uploadSuccess_frontIDCard"
                  ref="cardFrontUrl"
                  :sourceFileList="sourceFileList_cardFrontUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item>
                <div class="card">法定代表人身份证（反面）</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_backIDCard"
                  class="backIDCard"
                  :isSingle="false"
                  :maxlength="1"
                  ref="cardBackUrl"
                  :sourceFileList="sourceFileList_cardBackUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <div class="education-rule">
                *上传的身份证信息必须与营业执照法定代表人信息一致
              </div>
            </a-col>
          </div>
          <a-col :span="24">
            <div class="section18"></div>
          </a-col>
          <!-- 其他附件 -->

          <div class="attachments">
            <a-col :span="24">
              <div class="section4">
                <div class="mod4"></div>
                <span class="txt1">其他附件</span>
              </div>
            </a-col>

            <a-col :span="14">
              <a-form-item>
                <div class="card">办学许可证（选填）</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_schoolPermit"
                  class="schoolPermit"
                  :isSingle="false"
                  :maxlength="1"
                  :sourceFileList="sourceFileList_schoolPermitUrl"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <div class="card">其他材料（选填,至多可选五张）</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_otherMaterialsUrls"
                  class="otherMaterialsUrls"
                  :isSingle="false"
                  :maxlength="5"
                  :sourceFileList="reqDesc.otherMaterialsUrls"
                ></c-upload>
              </a-form-item>
            </a-col>
          </div>
        </a-row>
        <div class="section27"></div>
        <a-form-item class="footer">
          <a-button
            class="button"
            type="primary"
            :loading="saveloading"
            ghost
            @click="save"
          >
            保存
          </a-button>
          <a-button
            class="button"
            type="primary"
            html-type="submit"
            @click="submit"
            :loading="loading"
          >
            确认提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <!-- 高校与协会 -->
    <div v-if="this.state.institutionType === 3" class="four-one">
      <a-form :form="form" style="margin: 40px 0 0 39px">
        <a-row :gutter="24">
          <!-- 基本资料 -->
          <div class="basics">
            <div class="section4">
              <div class="mod4"></div>
              <span class="txt1">基本资料</span>
            </div>
            <a-col :span="12">
              <div class="title">高校与协会名称</div>
              <a-form-item>
                <a-input
                  v-decorator="[
                    'institutionName',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^[\u4e00-\u9fa5a-zA-Z]{2,25}$/,
                          message: '请输入长度为2~25位的高校与协会名称',
                        },
                      ],
                      getValueFromEvent: (event) => {
                        return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(
                          event.target.value
                        )
                          ? event.target.value
                          : event.target.value.slice(0, -1)
                      },
                      initialValue: this.state.institutionName,
                    },
                  ]"
                  placeholder="请输入高校与协会名称"
                />
              </a-form-item>
            </a-col>
            <a-col :span="14">
              <div class="title">详细地址</div>
              <a-form-item>
                <a-input
                  v-decorator="[
                    'address',
                    {
                      rules: [
                        {
                          required: true,
                          pattern: /^.{2,50}$/,
                          message: '请输入长度为2~50位的详细地址',
                        },
                      ],
                      getValueFromEvent: (event) => {
                        return event.target.value.trim()
                      },
                      initialValue: this.state.address,
                    },
                  ]"
                  placeholder="请填写详细地址"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <div class="title">联系人姓名</div>
              <a-form-item>
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'username',
                    {
                      rules: [
                        {
                          pattern: /^.{2,10}$/,
                          message: '请输入长度为2~10位的联系人姓名',
                        },
                      ],
                      initialValue: this.state.username,
                      validateTrigger: 'change',
                    },
                  ]"
                  placeholder="请输入联系人的真实姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <div class="title">联系人手机号</div>
              <a-form-item>
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'mobile',
                    {
                      rules: [
                        {
                          pattern: /^1[3456789]\d{9}$/,
                          message: '请输入正确的手机号',
                        },
                      ],
                      initialValue: this.state.mobile,
                      validateTrigger: 'change',
                    },
                  ]"
                  placeholder="请输入联系人的手机号"
                />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="24">
              <div class="section18"></div>
            </a-col> -->
          </div>
          <!-- 其他资料 -->

          <div class="attachments">
            <a-col :span="24">
              <div class="section4" style="margin-top: 15px">
                <div class="mod4"></div>
                <span class="txt1" style="width: 200px"
                  >高校与协会基本信息</span
                >
              </div>
            </a-col>

            <a-col :span="6">
              <!-- --------------------------------------------------------------------- -->
              <a-form-item :required="true">
                <div class="title" ref="LOGORef">上传LOGO:</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_LOGO"
                  class="LOGO"
                  :isSingle="false"
                  :maxlength="1"
                  ref="LOGO"
                  :sourceFileList="sourceFileList_LOGO"
                ></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="19">
              <a-form-item :required="true">
                <div class="title" ref="bgRef">上传背景图:</div>
                <c-upload
                  accept="image/*"
                  @uploadSuccess="uploadSuccess_backgroundImage"
                  class="backgroundImage"
                  ref="backgroundImage"
                  :isSingle="false"
                  :maxlength="1"
                  :imageMatchWidth="1125"
                  :imageMatchHeight="375"
                  :maxFileSize="2097152"
                  :sourceFileList="sourceFileList_backgroundImage"
                ></c-upload>
                <div class="remark">
                  注：用于展示高校与协会的底蕴风采，请上传1125*375像素的图片
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <div class="title">简介</div>
              <a-form-item>
                <a-textarea
                  v-decorator="[
                    'institutionIntro',
                    {
                      rules: [{ validator: teacherIntroRules }],
                      validateTrigger: 'blur',
                    },
                  ]"
                  placeholder="请简单介绍自己，多行输入"
                  :auto-size="{
                    minRows: 5,
                    maxRows: 6,
                  }"
                  :maxLength="2000"
                />
              </a-form-item>
            </a-col>
          </div>
        </a-row>
        <div class="section27"></div>
        <a-form-item class="footer">
          <a-button
            class="button"
            :loading="saveloading"
            type="primary"
            ghost
            @click="save"
          >
            保存
          </a-button>
          <a-button
            @click="submit"
            class="button"
            type="primary"
            html-type="submit"
            :loading="loading"
          >
            确认提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import bureau from '../../../api/bureau'
import user from '../../../api/user'
import school from '../../../api/school'
import CUpload from '../../../components/CUpload'
import moment from 'moment';
export default {
  components: {
    CUpload,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      state: {
        teacherGender: 0,
        teachingYears: 0,
        teacherIntro: '',
        cardNo:'',
        ...this.$store.state.register.form,
        educationInfoList: [
          {
            degreeUrl: '',
            degreeUrlList: [],
            graduatedSchool: '',
            recordSchooling: '',
            schoolingUrl: '',
            schoolingUrlList: []
          },
        ],
        auditFailed: true,
      },
      reqDesc: {
        teacherBareheadedImgUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        teacherImgUrl: '',
        healthUrl: [],
        noCrimeUrl: '',
        qualification: [],
        experience: [],
        certificateUrl: '',
        schoolPermitUrl: '',
        otherMaterialsUrls: [],
        logoImg: '',
        backgroundImg: '',
      },
      educationSelect: ['专科', '本科', '研究生', '博士', '其他'],
      addCount: 0,
      sourceFileList: [],
      bureauId: '',
      loading: false,
      saveloading: false,
      status: 0,
      sourceFileList_cardBackUrl: [],
      sourceFileList_cardFrontUrl: [],
      sourceFileList_fullFaced: [],
      sourceFileList_teacherImgUrl: [],
      sourceFileList_noCrimeUrl: [],
      //sourceFileList_qualification: [],
      //sourceFileList_experience: [],
      sourceFileList_certificateUrl: [],
      sourceFileList_diploma: [],
      sourceFileList_degreeUrl: [],
      sourceFileList_schoolPermitUrl: [],
      sourceFileList_LOGO: [],
      sourceFileList_backgroundImage: [],
      requiredSetting:[]
    }
  },
  created() {
    bureau.getBureauId().then((res) => {
      this.bureauId = res
    })
    if (this.state.status === 4) {
      this.state.auditFailed = false
    }
    if(this.state.institutionType == 2){
      this.getTeacherRequiredFields()
    }
  },
  mounted() {
    if (this.state.status === 4) {
      this.state.auditFailed = false
      this.dataBack()
    }
    if (this.state.status === 1) {
      let _this = this
      const h = this.$createElement
      this.$info({
        title: '未提交审核',
        content: h('div', {}, [
          h('p', '您的信息还未提交，请完善信息后点击-提交-送审。'),
        ]),
        onOk() {
          _this.dataBack()
        },
      })
    }
  },
  methods: {
    disabledDate(current) {
      return current && (current > moment().add(6,'months') || current < moment().startOf('day'));
    },
    getTeacherRequiredFields(){
      school.getTeacherRequiredFields({type:2}).then(res=>{
        this.requiredSetting = res.data.settingKeyValueDTOS
      })
    },
    teacherIntroRules(rule, value, callback) {
      if (!value) {
        callback('请输入简介')
      } else if (value.trim().length === 0) {
        callback('请输入正确的简介')
      }
      callback()
    },
    //删除学历按钮
    deleteEducation(i) {
      this.state.educationInfoList = this.state.educationInfoList.filter(
        (item, index) => i !== index
      )
      this.addCount = this.state.educationInfoList.length - 1

      this.disabledSelect(this.state.educationInfoList)
      console.log(this.state)

      // console.log(this.state.educationInfoList)
    },
    //数据回显
    dataBack() {
      const data = {
        ...this.state,
        educationInfoList: this.$store.state.register.form.educationInfoList,
      }
      if (data.institutionType === 2) {
        this.disabledSelect(data.educationInfoList)
      }
      console.log('data', data)
      if (data.teacherGender === 2) {
        this.form.setFieldsValue({ teacherGender: '女' })
      } else if (data.teacherGender === 1) {
        this.form.setFieldsValue({ teacherGender: '男' })
      }
      if (data.noCrimeExpiryDate !== 'null') {
        this.state.noCrimeExpiryDate = moment(data.noCrimeExpiryDate)
      }else {
        delete this.state.noCrimeExpiryDate
      }
      if (data.teacherIntro == 'undefined') {
        this.state.teacherIntro = ''
      } else {
        this.form.setFieldsValue({ teacherIntro: data.teacherIntro })
      }
      if (data.institutionIntro == 'undefined') {
        this.state.institutionIntro = ''
      } else {
        this.form.setFieldsValue({ institutionIntro: data.institutionIntro })
      }
      if (data.educationInfoList && data.educationInfoList.length !== 0) {
        this.state.educationInfoList = data.educationInfoList
        this.state.educationInfoList.forEach((item) =>
         {
          item.degreeUrlList = [];
          item.schoolingUrlList = [];
          if (item.degreeUrl) {
            item.degreeUrlList.push(item.degreeUrl)
          }
          if (item.schoolingUrl) {
            item.schoolingUrlList.push(item.schoolingUrl)
          }
        })
      }
      if (data.cardBackUrl) {
        this.sourceFileList_cardBackUrl.push(data.cardBackUrl) //身份证反面
      }
      if (data.cardFrontUrl) {
        this.sourceFileList_cardFrontUrl.push(data.cardFrontUrl) //身份证正面
      }
      if (data.teacherBareheadedImgUrl) {
        this.sourceFileList_fullFaced.push(data.teacherBareheadedImgUrl) //证件照
      }
      if (data.teacherImgUrl) {
        this.sourceFileList_teacherImgUrl.push(data.teacherImgUrl) //头像
      }
      if (data.healthUrl && data.healthUrl.length !== 0) {
        this.reqDesc.healthUrl = data.healthUrl //健康证明
      }
      if (data.noCrimeUrl) {
        this.sourceFileList_noCrimeUrl.push(data.noCrimeUrl) //无犯罪记录
      }
      if (data.qualification && data.qualification.length !== 0) {
        this.reqDesc.qualification = data.qualification //老师资质证书
      }
      if (data.experience && data.experience.length !== 0) {
        this.reqDesc.experience = data.experience //从业经验
      }
      if (data.certificateUrl) {
        this.sourceFileList_certificateUrl.push(data.certificateUrl) //营业执照
      }
      if (data.schoolPermitUrl) {
        this.sourceFileList_schoolPermitUrl.push(data.schoolPermitUrl) //办学许可证
      }
      if (data.otherMaterialsUrls && data.otherMaterialsUrls.length !== 0) {
        this.reqDesc.otherMaterialsUrls = data.otherMaterialsUrls //其他材料
      }
      if (data.logoImg) {
        this.sourceFileList_LOGO.push(data.logoImg) //LOGO
      }
      if (data.backgroundImg) {
        this.sourceFileList_backgroundImage.push(data.backgroundImg) //背景图片
      }
    },
    //保存信息
    save() {
      this.saveloading = true
      let value = this.form.getFieldsValue()
      let arr = []
      if (this.state.institutionType === 2) {
        this.state.educationInfoList.map((item, index) => {
          value.educationInfoList.map((i, v) => {
            if (index === v) {
              arr.push({ ...item, ...i })
              return arr
            }
          })
        })
      } else {
        arr = []
      }
      // let healthUrlDemo = []
      // if (this.reqDesc.healthUrl.length !== 0) {
      //   healthUrlDemo = this.reqDesc.healthUrl
      // }
      // let qualificationDemo = []
      // if (this.reqDesc.qualification.length !== 0) {
      //   qualificationDemo = this.reqDesc.qualification
      // }
      // let experienceDemo = []
      // if (this.reqDesc.experience.length !== 0) {
      //   experienceDemo = this.reqDesc.experience
      // }
      let teacherGenderDemo = 0
      if (value.teacherGender === '女') {
        teacherGenderDemo = 2
      } else if (value.teacherGender === '男') {
        teacherGenderDemo = 1
      }
      const data = {
        ...this.state,
        ...value,
        educationInfoList: JSON.stringify(arr),
        ...this.reqDesc,
        bureauId: this.bureauId,
        teacherGender:
          value.teacherGender == 1 || value.teacherGender == 2
            ? value.teacherGender
            : teacherGenderDemo,
        cardFrontUrl: (this.sourceFileList_cardFrontUrl.length > 0 ? this.sourceFileList_cardFrontUrl[0] : ''),
        cardBackUrl: (this.sourceFileList_cardBackUrl.length > 0 ? this.sourceFileList_cardBackUrl[0] : ''),
        teacherBareheadedImgUrl: (this.sourceFileList_fullFaced.length > 0 ? this.sourceFileList_fullFaced[0] : ''),
        teacherImgUrl: (this.sourceFileList_teacherImgUrl.length > 0 ? this.sourceFileList_teacherImgUrl[0] : ''),
        //healthUrl: healthUrlDemo, 在this.reqDesc.healthUrl
        noCrimeUrl: (this.sourceFileList_noCrimeUrl.length > 0 ? this.sourceFileList_noCrimeUrl[0] : ''),
        //qualification: qualificationDemo, 在this.reqDesc.qualification
        //experience: experienceDemo, 在this.reqDesc.experience
        certificateUrl: (this.sourceFileList_certificateUrl.length > 0 ? this.sourceFileList_certificateUrl[0] : ''),
        schoolPermitUrl: (this.sourceFileList_schoolPermitUrl.length > 0 ? this.sourceFileList_schoolPermitUrl[0] : ''),
        logoImg: (this.sourceFileList_LOGO.length > 0 ? this.sourceFileList_LOGO[0] : ''),
        backgroundImg: (this.sourceFileList_backgroundImage.length > 0 ? this.sourceFileList_backgroundImage[0] : ''),
      }
      // console.log('this.state', this.state)
      // console.log('value', value)
      // console.log('this.reqDesc', this.reqDesc)
      if(data.noCrimeExpiryDate){
        data.noCrimeExpiryDate = moment(data.noCrimeExpiryDate).format('YYYY-MM-DD')
      }else {
        data.noCrimeExpiryDate = null
      }
      if(!data.applyCourseType) delete data.applyCourseType
      user.saveInstitution(data).then((res) => {
        this.saveloading = false
        this.$message.success('保存成功')
      }).catch((err) => {
        this.saveloading = false
        console.error(err,'errerr')
      }).finally((err)=>{
        this.saveloading = false
      })
    },
    //新增学历
    addEducationInformation() {
      this.form.validateFieldsAndScroll(['educationInfoList'], (err, values) => {
      if (!err && this.requiredSetting[0].settingValue == '0' && this.requiredSetting[1].settingValue == '0') {
        let current = values.educationInfoList[values.educationInfoList.length - 1]
        console.log('current', current)
        if (!current.recordSchooling && !current.graduatedSchool) return this.$message.warning('请完善学历信息中的上一项')
        this.state.educationInfoList.push({
          degreeUrl: '',
          degreeUrlList: [],
          graduatedSchool: '',
          recordSchooling: '',
          schoolingUrl: '',
          schoolingUrlList: []
        })
        this.disabledSelect(values.educationInfoList)
        this.addCount += 1
        return
      } else if(!err && this.requiredSetting[0].settingValue == '1' && this.state.educationInfoList[this.addCount].schoolingUrl) {
        this.$refs.diploma[this.addCount].check()
        if(this.requiredSetting[1].settingValue == '1') {
          this.$refs.degreeImgUrl[this.addCount].check()
          if(!this.state.educationInfoList[this.addCount].degreeUrl) return
        }
        this.state.educationInfoList.push({
          degreeUrl: '',
          degreeUrlList: [],
          graduatedSchool: '',
          recordSchooling: '',
          schoolingUrl: '',
          schoolingUrlList: []
        })
        this.disabledSelect(values.educationInfoList)
        this.addCount += 1
      } else if (!err && this.requiredSetting[1].settingValue == '1' && this.state.educationInfoList[this.addCount].degreeUrl){
        this.$refs.degreeImgUrl[this.addCount].check()
        if(this.requiredSetting[0].settingValue == '1') {
          this.$refs.diploma[this.addCount].check()
          if(!this.state.educationInfoList[this.addCount].schoolingUrl) return
        }
        this.state.educationInfoList.push({
          degreeUrl: '',
          degreeUrlList: [],
          graduatedSchool: '',
          recordSchooling: '',
          schoolingUrl: '',
          schoolingUrlList: []
        })
        this.disabledSelect(values.educationInfoList)
        this.addCount += 1
        } else {
          if (this.requiredSetting[0].settingValue == '1') this.$refs.diploma[this.addCount].check()
          if (this.requiredSetting[1].settingValue == '1') this.$refs.degreeImgUrl[this.addCount].check()
        }
      })
    },
    validateFailedAlert() {
      this.$warning({
        title: "部分信息遗漏无法提交",
        content: "请仔细检查页面上方红字提示内容，并补全、上传缺少的内容，然后再次尝试提交审核。"
      });
    },
    //提交
    submit() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (this.state.institutionType === 2) {
          this.checkoutPerson(err).then(async (res) => {
            // console.log('res', res)
            if (!err && res === true) {
              this.loading = true
              let arr = []
              this.state.educationInfoList.map((item, index) => {
                values.educationInfoList.map((i, v) => {
                  if (index === v) {
                    arr.push({ ...item, ...i })
                    return arr
                  }
                })
              })

              let teacherGenderDemo
              if (values.teacherGender === '2') {
                teacherGenderDemo = 2
              } else if (values.teacherGender === '1') {
                teacherGenderDemo = 1
              } else if (
                values.teacherGender == '男' ||
                values.teacherGender == '女' ||
                values.teacherGender == '0'
              ) {
                teacherGenderDemo = this.state.teacherGender
              }
              console.log(values)
              console.log(this.state)
              const data = {
                ...this.state,
                ...values,
                educationInfoList: JSON.stringify(arr),
                ...this.reqDesc,
                bureauId: this.bureauId,
                teacherGender: teacherGenderDemo,
                noCrimeUrl: (this.sourceFileList_noCrimeUrl.length > 0 ? this.sourceFileList_noCrimeUrl[0] : ''),
                cardFrontUrl: (this.sourceFileList_cardFrontUrl.length > 0 ? this.sourceFileList_cardFrontUrl[0] : ''),
                cardBackUrl: (this.sourceFileList_cardBackUrl.length > 0 ? this.sourceFileList_cardBackUrl[0] : ''),
                teacherBareheadedImgUrl: (this.sourceFileList_fullFaced.length > 0 ? this.sourceFileList_fullFaced[0] : ''),
                teacherImgUrl: (this.sourceFileList_teacherImgUrl.length > 0 ? this.sourceFileList_teacherImgUrl[0] : ''),
              }
              if(data.noCrimeExpiryDate){
                data.noCrimeExpiryDate = moment(data.noCrimeExpiryDate).format('YYYY-MM-DD')
              } else {
                data.noCrimeExpiryDate = null
              }
              // console.log('this.state', this.state)
              // console.log('value', values)
              // console.log('this.reqDesc', this.reqDesc)
              console.log('data', data)
              await user
                .submitInformation(data)
                .then((res) => {
                  this.loading = false
                  if (res.data.status === 2) {
                    this.status = 2
                    this.$store.commit('register/changeStatus', this.status)
                    this.$emit('nextStep', 1)
                  }
                })
                .catch((e) => {
                  this.loading = false
                })
            } else {
              this.validateFailedAlert()
            }
          })
        } else if (this.state.institutionType === 1) {
          this.checkoutInstitution(err).then(async (res) => {
            if (!err && res) {
              this.loading = true
              const data = {
                ...this.state,
                ...values,
                ...this.reqDesc,
                bureauId: this.bureauId,
                educationInfoList: JSON.stringify([]),
                cardFrontUrl: (this.sourceFileList_cardFrontUrl.length > 0 ? this.sourceFileList_cardFrontUrl[0] : ''),
                cardBackUrl: (this.sourceFileList_cardBackUrl.length > 0 ? this.sourceFileList_cardBackUrl[0] : ''),
                certificateUrl: (this.sourceFileList_certificateUrl.length > 0 ? this.sourceFileList_certificateUrl[0] : ''),
                schoolPermitUrl: (this.sourceFileList_schoolPermitUrl.length > 0 ? this.sourceFileList_schoolPermitUrl[0] : ''),
              }
              console.log('...values', values)
              console.log('...this.reqDesc', this.reqDesc)
              console.log('...this.state', this.state)
              console.log('data', data)
              await user
                .submitInformation(data)
                .then((res) => {
                  this.loading = false
                  if (res.data.status === 2) {
                    this.status = 2
                    this.$store.commit('register/changeStatus', this.status)
                    this.$emit('nextStep', 1)
                  }
                  console.log(res)
                })
                .catch((e) => {
                  this.loading = false
                })
            } else {
              this.validateFailedAlert()
            }
          })
        } else if (this.state.institutionType === 3) {
          this.checkoutUniversities(err).then(async (res) => {
            if (!err && res) {
              this.loading = true
              const data = {
                ...this.state,
                ...values,
                ...this.reqDesc,
                bureauId: this.bureauId,
                educationInfoList: JSON.stringify([]),
                logoImg: (this.sourceFileList_LOGO.length > 0 ? this.sourceFileList_LOGO[0] : ''),
                backgroundImg: (this.sourceFileList_backgroundImage.length > 0 ? this.sourceFileList_backgroundImage[0] : ''),
              }
              console.log('submitdata', data)
              await user
                .submitInformation(data)
                .then((res) => {
                  this.loading = false
                  if (res.data.status === 2) {
                    this.status = 2
                    this.$store.commit('register/changeStatus', this.status)
                    this.$emit('nextStep', 1)
                  }
                  // console.log(res)
                })
                .catch((e) => {
                  this.loading = false
                })
            } else {
              this.validateFailedAlert()
            }
          })
        }
      })
    },
    //校验个人
    checkoutPerson(err) {
      return new Promise((resolve) => {
        console.log(
          'this.state.educationInfoList',
          this.state.educationInfoList
        )
        let qualificationFlag
        let degreeFlag
        this.state.educationInfoList.forEach((item, index) => {
          console.log(item,index)
          if(this.requiredSetting[0].settingValue == '0') return qualificationFlag = true
          this.$refs.diploma[index].check()
          return qualificationFlag = !item.schoolingUrl ? false : true
        })
        this.state.educationInfoList.forEach((item, index) => {
          if(this.requiredSetting[1].settingValue == '0') return degreeFlag = true
          this.$refs.degreeImgUrl[index].check()
          return degreeFlag = !item.degreeUrl ? false : true
        })
        Promise.all([
          this.requiredSetting[5].settingValue == '1'? this.$refs.teacherBareheadedImgUrl.check() : true, // 免冠照
          this.$refs.teacherImgUrl.check(), // 头像
          qualificationFlag, // 学历
          degreeFlag, // 学位
          this.requiredSetting[10].settingValue == '1'? this.$refs.cardFrontUrl.check() : true, // 身份证正面
          this.requiredSetting[10].settingValue == '1'? this.$refs.cardBackUrl.check() : true, // 身份证反面
          this.requiredSetting[4].settingValue == '1'? this.$refs.healthImgUrl.check() : true, // 健康证明
          this.requiredSetting[6].settingValue == '1'? this.$refs.qualification.check() : true, // 师资
          this.requiredSetting[2].settingValue == '1'? this.$refs.noCrimeImgUrl.check() : true, // 无犯罪记录证明
          this.requiredSetting[8].settingValue == '1'? this.$refs.experienceUrl.check() : true, // 从业经验
        ]).then((res) => {
          console.log('res1', res)
          let res1 = res.every((item) => item === true)
          resolve(res1)
          if(err) return
          if((!res[0] || !res[1])){
            this.$refs.avatarRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
            return
          }
          if(!res[2] || !res[3]){
            this.$refs.educationRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
            return
          }
          if((!res[4] || !res[5])){
            this.$refs.IDCardRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
          }
          if(!res[6]){
            this.$refs.healthImgRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
            return
          }
        })
      })
    },
    //校验课程方
    checkoutInstitution(err) {
      return new Promise((resolve) => {
        Promise.all([
          this.$refs['certificateUrl'].check(),
          this.$refs['cardFrontUrl'].check(),
          this.$refs['cardBackUrl'].check(),
        ]).then((res) => {
          let res1 = res.every((item) => item === true)
          resolve(res1)
          if(!err && !res[0]){
            this.$refs.certificateRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
            return;
          }
          if(!err && (!res[1] || !res[2])){
            this.$refs.corporationRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
          }
        })
      })
    },
    //校验高校与协会
    checkoutUniversities(err) {
      return new Promise((resolve) => {
        Promise.all([
          this.$refs['LOGO'].check(),
          this.$refs['backgroundImage'].check(),
        ]).then((res) => {
          let res1 = res.every((item) => item === true)
          resolve(res1)
          if(!err && !res[0]){
            this.$refs.LOGORef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
            return;
          }
          if(!err && !res[1]){
            this.$refs.bgRef.scrollIntoView({
              behavior: 'smooth', 
              block: 'start' 
            });
          }
        })
      })
    },
    //学历下拉框
    disabledSelect(values) {
      console.log('disabledSelectvalues', values)
      let educationSelect = ['专科', '本科', '研究生', '博士', '其他']
      this.educationSelect = educationSelect.filter(
        (item) => !values.map((item) => item.recordSchooling).includes(item)
      )
    },
    //正面免冠照片
    uploadSuccess_fullFaced(url) {
      if (url.length > 0) {
        this.reqDesc.teacherBareheadedImgUrl = url[0].url
      } else {
        this.reqDesc.teacherBareheadedImgUrl = ""
      }
    },
    //头像
    uploadSuccess_headPortrait(url) {
      if (url.length > 0) {
        this.reqDesc.teacherImgUrl = url[0].url
      } else {
        this.reqDesc.teacherImgUrl = ""
      }
    },
    //学历证
    uploadSuccess_diploma(url, index) {
      if (url.length > 0) {
        this.state.educationInfoList[index].schoolingUrl = url[0].url
      } else {
        this.state.educationInfoList[index].schoolingUrl = ''
      }
    },
    //学位证
    uploadSuccess_degreeUrl(url, index) {
      if (url.length > 0) {
        this.state.educationInfoList[index].degreeUrl = url[0].url
      } else {
        this.state.educationInfoList[index].degreeUrl = ''
      }
    },
    //身份证正面
    uploadSuccess_frontIDCard(url) {
      if (url.length > 0) {
        this.reqDesc.cardFrontUrl = url[0].url
      } else {
        this.reqDesc.cardFrontUrl = ""
      }
    },
    //身份证反面
    uploadSuccess_backIDCard(url) {
      if (url.length > 0) {
        this.reqDesc.cardBackUrl = url[0].url
      } else {
        this.reqDesc.cardBackUrl = ""
      }
    },
    //健康证明
    // uploadSuccess_health(list) {
    //   let arr = []
    //   list.map((item) => {
    //     arr.push(item.url)
    //     return arr
    //   })
    //   this.reqDesc.healthUrl = arr
    // },
    //无犯罪记录证明
    // uploadSuccess_criminal(url) {
    //   if (url.length > 0) {
    //     this.reqDesc.noCrimeUrl = url[0].url
    //   } else {
    //     this.reqDesc.noCrimeUrl = ""
    //   }
    // },
    // 老师资质证书
    // uploadSuccess_qualification(list) {
    //   let arr = []
    //   list.map((item) => {
    //     arr.push(item.url)
    //     return arr
    //   })
    //   this.reqDesc.qualification = arr
    // },
    // 从业经验
    // uploadSuccess_experience (list) {
    //   let arr = []
    //   list.map((item) => {
    //     arr.push(item.url)
    //     return arr
    //   })
    //   this.reqDesc.experience = arr
    // },
    //营业执照
    uploadSuccess_certificateUrl(url) {
      if (url.length > 0) {
        this.reqDesc.certificateUrl = url[0].url
      } else {
        this.reqDesc.certificateUrl = ""
      }
    },
    //办学许可证
    uploadSuccess_schoolPermit(url) {
      if (url.length > 0) {
        this.reqDesc.schoolPermitUrl = url[0].url
      } else {
        this.reqDesc.schoolPermitUrl = ""
      }
    },
    //其他资料
    uploadSuccess_otherMaterialsUrls(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.otherMaterialsUrls = arr
    },
    //LOGO
    uploadSuccess_LOGO(url) {
      if (url.length > 0) {
        this.reqDesc.logoImg = url[0].url
      } else {
        this.reqDesc.logoImg = null
      }
    },
    //背景图
    uploadSuccess_backgroundImage(url) {
      if (url.length > 0) {
        this.reqDesc.backgroundImg = url[0].url
      } else {
        this.reqDesc.backgroundImg = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
.header {
  margin: 13px 0 0 6px;
}
.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}
.wrap1 {
  display: inline-block;
  height: 50px;
  vertical-align: middle;
  margin-left: 23px;
  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }
  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}
.box3 {
  z-index: 19;
  width: 100%;
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin: 37px 20px 40px 10px;
}
.section4 {
  z-index: auto;
  height: 22px;
  margin-bottom: 39px;
}

.mod4 {
  z-index: 79;
  width: 9px;
  height: 20px;
  border-radius: 4.5px 4.5px 4.5px 4.5px;
  background-color: rgba(78, 148, 255, 1);
  margin-top: 1px;
  display: inline-block;
}

.txt1 {
  z-index: 65;
  width: 80px;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(78, 148, 255, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  line-height: 22px;
  text-align: left;
  vertical-align: top;
  margin-left: 12px;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.education {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.education-rule {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff7032;
  margin-bottom: 20px;
}
.section18 {
  z-index: 38;
  width: 100%;
  height: 4px;
  background-color: rgba(248, 248, 248, 1);
  align-self: center;
  margin: 10px 0;
}
.card {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.section27 {
  z-index: 35;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 40px;
}
.button {
  width: 140px;
  height: 42px;
  margin-left: 24px;
}
.footer {
  text-align: center;
  margin-top: 23px;
}
.remark {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #87888a;
  line-height: 20px;
}

/deep/ .fullFaced .ant-upload {
  width: 160px;
  height: 242px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .fullFaced .ant-spin-nested-loading {
  width: 160px;
}

//背景图
/deep/ .backgroundImage .ant-upload {
  width: 750px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .backgroundImage .ant-spin-nested-loading {
  width: 750px;
}
/deep/ .backgroundImage .ant-upload-list-picture-card-container {
  width: 750px;
  height: 250px;
  border: 0;
}
/deep/ .backgroundImage .ant-upload-list-item {
  width: 750px;
  height: 250px;
  border: 0;
}
/deep/ .certificateUrl .ant-spin-nested-loading {
  width: 297px;
}
/deep/ .certificateUrl .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
  .ant-spin-nested-loading {
    width: 297px;
  }
}
/deep/ .schoolPermit .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .schoolPermit .ant-spin-nested-loading {
  width: 297px;
}
//头像
/deep/ .headPortrait .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .headPortrait .ant-spin-nested-loading {
  width: 160px;
}
//LOGO
/deep/ .LOGO .ant-upload {
  width: 250px;
  height: 250px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .LOGO .ant-spin-nested-loading {
  width: 250px;
}
/deep/ .LOGO .ant-upload-list-picture-card-container {
  width: 250px;
  height: 250px;
  border: 0;
}
/deep/ .LOGO .ant-upload-list-item {
  width: 250px;
  height: 250px;
  border: 0;
}
/deep/ .diploma .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .diploma .ant-spin-nested-loading {
  width: 160px;
}
/deep/ .frontIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  background: url(/home/frontIDCard.png) no-repeat center;
  background-size: 100% 100%;
  .ant-upload-text {
    display: none;
  }
  .anticon-plus {
    display: none;
  }
  .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
    left: 33%;
  }
}

/deep/ .backIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  margin-left: 0px;
  background: url(/home/backIDCard.png) no-repeat center;
  background-size: 100% 100%;
  .ant-upload-text {
    display: none;
  }
  .anticon-plus {
    display: none;
  }
}
/deep/ .prove .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}
/deep/ .prove .ant-spin-nested-loading {
  width: 160px;
}
/deep/ .otherMaterialsUrls .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}
/deep/ .proveHealth .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  /deep/ .ant-upload-list-item-list-type-picture-card {
    width: 160px;
    height: 160px;
    border: 0;
  }
  /deep/ .ant-upload-list-item {
    width: 160px;
    height: 160px;
    border: 0;
  }
  .ant-upload-text {
    display: none;
  }
}
/deep/ .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .fullFaced .ant-upload-list-item {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .fullFaced .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .certificateUrl .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}
/deep/ .certificateUrl .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}
/deep/ .schoolPermit .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}
/deep/ .certificateUrl .ant-spin-nested-loading {
  width: 297px;
}
/deep/ .schoolPermit .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-picture-card-wrapper {
  width: 100%;
}

/deep/ .frontIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}
/deep/ .frontIDCard .ant-spin-nested-loading {
  width: 320px;
}
/deep/ .frontIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .backIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

/deep/ .backIDCard .ant-spin-nested-loading {
  width: 320px;
}
/deep/ .backIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .btn {
  width: 36px;
  height: 25px;
  font-size: 17px;
  margin-top: 10px;
  vertical-align: bottom;
}

.outer9 {
  z-index: 37;
  width: 130%;
  height: 1px;
  // background-color: #000;
  background-color: #f8f8f8;
  margin-top: 20px;
  margin-bottom: 20px;
}
.title{
  text-align: left;
}

.require{
  padding-left: 5px;
  color: red;
  font-size:14px;
  font-weight:400;
}
</style>
